module.exports = __webpack_public_path__ + "static/media/2.4437b4c3.png";